// Phase 3 — design version switcher (V1 / V2 / V3 / V4).
// Writes <html data-version="v1|v2|v3|v4"> so CSS can layer an entirely
// different skin per version without changing any component code or
// behavior. V4 is a mobile-first layout with bottom tab navigation.
// Preference persists in localStorage. V1 is the default.

import React, { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "gabruz-version";
const VersionCtx = createContext(null);

function applyVersion(v) {
  if (typeof document !== "undefined") {
    document.documentElement.dataset.version = v;
  }
}

const VALID = ["v1", "v2", "v3", "v4"];
function readInitial() {
  if (typeof localStorage === "undefined") return "v1";
  const saved = localStorage.getItem(STORAGE_KEY);
  return VALID.includes(saved) ? saved : "v1";
}

export function VersionProvider({ children }) {
  const [version, setVersionState] = useState(readInitial);

  useEffect(() => { applyVersion(version); }, [version]);

  function setVersion(next) {
    if (!VALID.includes(next)) return;
    setVersionState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* ignore */ }
  }
  // Cycles v1 → v2 → v3 → v4 → v1.
  function toggleVersion() {
    const i = VALID.indexOf(version);
    setVersion(VALID[(i + 1) % VALID.length]);
  }

  return (
    <VersionCtx.Provider value={{ version, setVersion, toggleVersion }}>
      {children}
    </VersionCtx.Provider>
  );
}

export function useVersion() {
  const ctx = useContext(VersionCtx);
  if (!ctx) throw new Error("useVersion must be used inside <VersionProvider>");
  return ctx;
}
